var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"info-box"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}}),_c('div',{staticClass:"info-box-close",on:{"click":function($event){return _vm.closeInfo()}}},[_c('span',{attrs:{"data-tooltip":_vm.translations.labels.dismiss}},[_c('i',{staticClass:"el-icon-close"})])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }